import { QpLoadingProvider } from "./qp-loading.provider";

import "./qp-load.less";

angular.module("qp-loading-template", []).run(["$templateCache", function ($templateCache) {
    $templateCache.put("qp-loading-template.html", require('./qp-loading.html').default);
}]);

let module_name = "qp-loading";

let LoadingModule = angular.module(module_name, ["qp-loading-template"]);

LoadingModule.provider("qpLoading", QpLoadingProvider);


export { LoadingModule, module_name }